import React, { createContext, useEffect, useState } from "react";

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  // 초기 로드 시 localStorage 또는 sessionStorage에서 토큰 복원
  const getInitialAuth = () => {
    // 1순위: localStorage (Remember me로 저장된 경우)
    const localAuth = localStorage.getItem("auth");
    if (localAuth) {
      try {
        return JSON.parse(localAuth);
      } catch (e) {
        console.error("Failed to parse localStorage auth:", e);
      }
    }

    // 2순위: sessionStorage (현재 세션)
    const sessionAuth = sessionStorage.getItem("auth");
    if (sessionAuth) {
      try {
        return JSON.parse(sessionAuth);
      } catch (e) {
        console.error("Failed to parse sessionStorage auth:", e);
      }
    }

    return {};
  };

  const [auth, setAuth] = useState(getInitialAuth());

  useEffect(() => {
    // sessionStorage는 항상 업데이트 (현재 세션 유지)
    sessionStorage.setItem("auth", JSON.stringify(auth));

    // localStorage는 이미 존재하는 경우에만 업데이트 (Remember me 체크된 경우)
    // 이렇게 하면 SignIn.jsx에서 Remember me 체크 여부로 localStorage 사용을 제어할 수 있음
    if (localStorage.getItem("auth")) {
      localStorage.setItem("auth", JSON.stringify(auth));
    }
  }, [auth]);

  const [selectedFormType, setSelectedFormType] = useState(
    sessionStorage.getItem("selectedFormType") ? JSON.parse(sessionStorage.getItem("selectedFormType")) : {}
  );
  useEffect(() => {
    sessionStorage.setItem("selectedFormType", JSON.stringify(selectedFormType));
  }, [selectedFormType]);

  const [notifications, setNotifications] = useState([]);

  const [stores, setStores] = useState([]);

  return (
    <AppContext.Provider
      value={{
        auth,
        setAuth,
        selectedFormType,
        setSelectedFormType,
        notifications,
        setNotifications,
        stores,
        setStores,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
